import { Navigate, Outlet, useLocation, useParams } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "features/config/hooks";
import { useEffect } from "react";
import {
  getAdminSession,
  selectGetAdminSession,
  GetAdminSessionState,
} from "features/admin/presentation/slices/get-admin-session.slice";
import { stockUserNotification } from "../slices/user-notification.slice";
import {
  selectStockActiveProcess,
  stockActiveProcess,
} from "../slices/stock-active-process.slice";
import { createQueryParams } from "features/config/helpers";

export function StockOrderingPermissionGuard() {
  const dispatch = useAppDispatch();
  const { view } = useParams();
  const location = useLocation();

  const stockActiveProcessState = useAppSelector(selectStockActiveProcess);
  const getAdminSessionState = useAppSelector(selectGetAdminSession);

  useEffect(() => {
    dispatch(getAdminSession());
    dispatch(stockActiveProcess(createQueryParams({ type: view })));
    dispatch(stockUserNotification());
  }, [dispatch]);

  if (getAdminSessionState.data?.stock_maintenance) {
    return <Navigate to={"/admin/material/sorry"} />;
  }

  // if (view !== "selling" && view !== "order") {
  //   return <Navigate to={"/unauthorize"} />;
  // }

  if (stockActiveProcessState.data?.process.length === 0) {
    return <Navigate to={"/admin"} />;
  }

  if (
    getAdminSessionState.status === GetAdminSessionState.fail &&
    getAdminSessionState.data === null
  ) {
    return <Navigate to={"/admin"} />;
  }

  if (
    getAdminSessionState.data?.admin.user_details.sos_groups.length === 0 &&
    getAdminSessionState.data?.admin.user_details.sos_groups_seller.length === 0
  ) {
    return <Navigate to={"/unauthorize"} />;
  }

  if (
    getAdminSessionState.data &&
    getAdminSessionState.status === GetAdminSessionState.success
  ) {
    return (
      <>
        <Outlet />
      </>
    );
  }

  return null;
}
